import CloseIcon from '@mui/icons-material/Close';

export const TITLE_BAR_ACTIONS = (onClose) => [
  { icon: <CloseIcon sx={{ fontSize: 16 }} />, title: 'Close', onClick: onClose },
];
